if (document.referrer && $('.back-button').length) {
    $('.back-button').each(function () {
        $(this).attr('href', document.referrer);
    });
} else if (!document.referrer) {
    $('.back-button').hide();
}
